import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  Button,
  IconButton,
  InputAdornment,
  Typography,
  Grid,
  CircularProgress,
  TextField,
} from "@mui/material";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { useMediaQuery, useTheme } from "@mui/material";

import { useSnackbar } from "notistack";

import Logo from "@assets/images/logo.png";

import { CognitoAPI } from "@services/API";

export default function ResetPassword({ ...props }) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const history = useHistory();
  const location = useLocation();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState(localStorage.getItem("email"));
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  const showSnackBar = (type, title, subtitle) => {
    const options = { variant: type };

    enqueueSnackbar(
      <div style={{ display: "inline-grid" }}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="subtitle1">{subtitle}</Typography>
      </div>,
      options
    );
  };

  const isNullOrEmpty = (value) => {
    if (value === null || value === undefined) {
      return true;
    }

    if (typeof value === "string" && value.trim().toLowerCase() === "null") {
      return true;
    }

    if (Array.isArray(value) && value.length === 0) {
      return true;
    }

    if (typeof value === "string" && value.trim() === "") {
      return true;
    }

    if (typeof value === "number" && isNaN(value)) {
      return true;
    }

    return false;
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const isValidEmail = (email) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    } else {
      return false;
    }
  };

  const isValidPassword = (value) => {
    let regEx =
      /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*_\-+=`|(){}\[\]:;"'<>,.?/])(?=\S+$).{8,20}$/;
    return regEx.test(value);
  };

  const handleUpdate = (event) => {
    event.preventDefault();

    if (isNullOrEmpty(email)) {
      showSnackBar("error", "Failure", "Email can`t be empty.");
    } else if (!isValidEmail(email)) {
      showSnackBar("error", "Failure", "Invalid email address.");
    } else if (isNullOrEmpty(code)) {
      showSnackBar("error", "Failure", "Code can`t be empty.");
    } else if (isNullOrEmpty(password)) {
      showSnackBar("error", "Failure", "Password can`t be empty.");
    } else if (!isValidPassword(password)) {
      showSnackBar(
        "error",
        "Failure",
        "Password must contain at least 8 characters and at most 20 characters, with at least one digit, one upper case letter, one lower case letter, and one special character from the set:\n\n ~!@#$%^&*_-+=`|(){}[]:;'<\">,.?/\n\nIt must not contain any white space."
      );
    } else {
      setLoading(true);

      CognitoAPI.post(`/confirmpassword`, {
        UserName: email.trim(),
        Code: code.trim(),
        Password: password.trim(),
      })
        .then((response) => {
          if (response.data.token) {
            history.push("/login");
          }
        })
        .catch((error) => {
          setLoading(false);
          showSnackBar("error", "Failure", "Internal server error.");
        });
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "85vh",
      }}
    >
      <Grid
        container
        spacing={2}
        style={{ width: isSmallScreen ? "90%" : "500px" }}
      >
        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <img src={Logo} alt="logo" height="100px" />
        </Grid>

        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Typography
            variant="h3"
            color={"primary"}
            style={{ fontWeight: "bold" }}
          >
            Administration Portal
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography>
            Enter in the code that you just received in your email and your
            updated password.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField
            variant="outlined"
            id="email"
            label="Email"
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            required
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            variant="outlined"
            id="code"
            label="Code"
            type="code"
            onChange={(e) => setCode(e.target.value)}
            value={code}
            autoFocus
            required
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            variant="outlined"
            id="password"
            label="New Password"
            type={showPassword ? "text" : "password"}
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            required={true}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={togglePasswordVisibility}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Button
            variant="contained"
            type={"submit"}
            size={"large"}
            loading={loading}
            disabled={loading}
            onClick={handleUpdate}
            fullWidth
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Update Password"
            )}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
